import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { FlexModule } from 'ng-flex-layout/flex';

@Component({
  selector: 'pr-warning',
  templateUrl: './warning.component.html',
  styleUrls: ['./warning.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIconModule, FlexModule],
})
export class WarningComponent {
  @Input() warning = '';
}
